import React, { useEffect, useState } from 'react';
import api from '../api/axiosConfig';
import './CompaniesPage.css';
import '../styles/rowActions.css';

export default function CompaniesPage() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);

  const [newName, setNewName] = useState('');
  const [creating, setCreating] = useState(false);

  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');
  const [savingId, setSavingId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  const loadCompanies = () => {
    setLoading(true);
    return api.get('companies/')
      .then((r) => setCompanies(r.data))
      .catch(() => setStatus({ type: 'error', text: 'No se pudieron cargar las empresas.' }))
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadCompanies(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    setCreating(true);
    setStatus(null);
    try {
      const r = await api.post('companies/', { name: newName.trim() });
      setCompanies((cs) => [...cs, r.data].sort((a, b) => a.name.localeCompare(b.name)));
      setNewName('');
    } catch (err) {
      setStatus({ type: 'error', text: 'No se pudo crear la empresa.' });
    } finally {
      setCreating(false);
    }
  };

  const startEdit = (c) => {
    setEditingId(c.id);
    setEditName(c.name);
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditName('');
  };

  const handleSaveEdit = async (id) => {
    if (!editName.trim()) return;
    setSavingId(id);
    setStatus(null);
    try {
      const r = await api.patch(`companies/${id}/`, { name: editName.trim() });
      setCompanies((cs) => cs.map((c) => (c.id === id ? r.data : c)));
      cancelEdit();
    } catch (err) {
      setStatus({ type: 'error', text: 'No se pudieron guardar los cambios.' });
    } finally {
      setSavingId(null);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar esta empresa?')) return;
    setDeletingId(id);
    setStatus(null);
    try {
      await api.delete(`companies/${id}/`);
      setCompanies((cs) => cs.filter((c) => c.id !== id));
    } catch (err) {
      setStatus({ type: 'error', text: 'No se pudo eliminar la empresa.' });
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="companies-root">
      <h1 className="companies-title">🏢 Empresas</h1>

      <form className="companies-add-form" onSubmit={handleCreate}>
        <input
          className="companies-add-input"
          placeholder="Nombre de la nueva empresa"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
        />
        <button className="companies-add-btn" type="submit" disabled={creating || !newName.trim()}>
          {creating ? 'Agregando…' : '+ Agregar empresa'}
        </button>
      </form>

      {status && <div className={`companies-status companies-status-${status.type}`}>{status.text}</div>}

      <div className="companies-card">
        {loading ? (
          <div className="companies-empty">Cargando…</div>
        ) : companies.length === 0 ? (
          <div className="companies-empty">Aún no hay empresas.</div>
        ) : (
          <table className="companies-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Creado por</th>
                <th>Creado</th>
                <th>Editado por</th>
                <th>Modificado</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {companies.map((c) => (
                <tr key={c.id}>
                  <td>
                    {editingId === c.id ? (
                      <input
                        className="companies-edit-input"
                        value={editName}
                        onChange={(e) => setEditName(e.target.value)}
                        autoFocus
                      />
                    ) : (
                      c.name
                    )}
                  </td>
                  <td>{c.created_by_username || '—'}</td>
                  <td>{new Date(c.created).toLocaleDateString()}</td>
                  <td>{c.last_edited_by_username || '—'}</td>
                  <td>{new Date(c.modified).toLocaleDateString()}</td>
                  <td>
                    <div className="row-actions">
                      {editingId === c.id ? (
                        <>
                          <button
                            className="row-icon-btn"
                            onClick={() => handleSaveEdit(c.id)}
                            disabled={savingId === c.id}
                            title="Guardar"
                            aria-label="Guardar"
                          >
                            {savingId === c.id ? '…' : '💾'}
                          </button>
                          <button className="row-icon-btn" onClick={cancelEdit} title="Cancelar" aria-label="Cancelar">✖️</button>
                        </>
                      ) : (
                        <>
                          <button className="row-icon-btn" onClick={() => startEdit(c)} title="Editar" aria-label="Editar">✏️</button>
                          <button
                            className="row-icon-btn"
                            onClick={() => handleDelete(c.id)}
                            disabled={deletingId === c.id}
                            title="Eliminar"
                            aria-label="Eliminar"
                          >
                            {deletingId === c.id ? '…' : '🗑️'}
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
